import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";
import { IconCheck, IconTrash, IconX } from '@tabler/icons-react';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { Modal, Button, Input, Group, Text, ActionIcon } from '@mantine/core';

export function DiscardTest({ pageId, taguchiTestId, testId, selectedMemberWebsite, systemUsageLoader }:any) {
  const navigate = useNavigate();
  const [discardTestValue, setDiscardTestValue] = useState('');
  const [error, setError] = useState('');
  const [isDiscardTestModelOpen, setIsDiscardTestModelOpen] = useState(false);

  const handleDiscardTestClick = () => {
    setIsDiscardTestModelOpen(true);
  };

  const handleDiscardTest = () => {
    if(discardTestValue.trim() === 'DISCARD'){
      setIsDiscardTestModelOpen(false);
      setDiscardTestValue('');
      setError('');
      systemUsageLoader(true);
      TestsApi.discardtest({
        system_website_id: selectedMemberWebsite,
        page_id:pageId,
        taguchi_test_id:taguchiTestId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          systemUsageLoader(false);
          notifications.show({
            color: 'green',
            icon: <IconCheck size="1.1rem" />,
            title: 'Success',
            message: data.message,
          });
          navigate('/review-tests');
        } else {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
          systemUsageLoader(false);
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        systemUsageLoader(false);
      });
    }else{
      setError('Word does not match.');
    }
  }

  return (
    <>
      <ActionIcon 
        variant="default"
        size="lg"
        sx={(theme) => ({
           backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#fff",
         })}
        title="Discart Test"
        ml={5}
        onClick={() => handleDiscardTestClick()}
      >
        <IconTrash size="1.1rem" />
      </ActionIcon>
      <Modal
        opened={isDiscardTestModelOpen}
        onClose={() => {
          setDiscardTestValue('');
          setError('');
          setIsDiscardTestModelOpen(false);
        }}
        title="Discard Test"
        trapFocus={false}
      >
        <Text size="sm" style={{ userSelect: 'none' }}>
          This will discard your current test so you will loose all data. Do you wish to continue? Then you should remove the webhook from the shopping cart or payment processor after delete campaign.If you want to proceed, please enter the word <b>DISCARD</b> below:
        </Text>
        <Input
          mt={10}
          mb={10}
          value={discardTestValue}
          onChange={(e) => {
            const value = e.currentTarget.value;
            setDiscardTestValue(value);
            if (value.trim() === 'DISCARD') {
              setError('');
            }
          }}
        />
        {error && (
          <Text color="red" size="sm" mt={10}>
            {error}
          </Text>
        )}
        <Group position="right">
          <Button onClick={() => handleDiscardTest()}>OK</Button>
        </Group>
      </Modal>
    </>
  );
}